/*
 * @Description: file content
 * @Author:
 * @Date: 2023-08-22 11:43:42
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-08-21 14:06:39
 */
const LoginView = () => import('@/features/auth/views/LoginViewNew.vue')
const AutoCodeView = () => import('@/features/auth/views/AuthCodeView.vue')
const NotFroundView = () => import('@/features/exception/views/404.vue')
const ErrorView = () => import('@/features/exception/views/500.vue')
const DemoView = () => import('@/features/demo/views/DemoView.vue')
const DemoChatView = () => import('@/features/demo/chat/index.vue')
const InvitationView = () => import('@/features/invitation/views/InvitationView.vue') // 邀请链接
const CompanyInvitationView = () => import('@/features/personal-center/views/CompanyInvitationView.vue') // 个人中心 > 邀请中间页
const UserInfoView = () => import('@/features/auth/views/UserInfoView.vue') // 信息填写页
const AuthCrxView = () => import('@/features/auth-crx/index.vue')
const UserProtocolView = () => import('@/features/auth/views/UserProtocol.vue') // 用户协议
const PrivacyPolicyView = () => import('@/features/auth/views/PrivacyPolicy.vue') // 隐私政策

export const publicRoutes = [
  {
    path: '/',
    name: 'Root',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: '登录页', posthogTitle: '登录页' },
  },
  {
    path: '/auth',
    name: 'Auth',
    component: AutoCodeView,
    meta: { title: '登录页', posthogTitle: '登录页' },
  },
  {
    path: '/auth-crx',
    name: 'AuthCrx',
    component: AuthCrxView,
    meta: { title: '登录页', posthogTitle: '登录页' },
  },
  {
    path: '/userInfo',
    name: 'UserInfo',
    component: UserInfoView,
    meta: { title: '信息填写页', posthogTitle: '信息填写页' },
  },
  {
    path: '/invitation', // 邀请链接
    name: 'Invitation',
    component: InvitationView,
    meta: { title: '邀请页' },
  },
  {
    path: '/company-invitation',
    name: 'CompanyInvitationView',
    component: CompanyInvitationView,
    meta: { title: '企业邀请', posthogTitle: '企业邀请中间页' },
  },
  {
    path: '/404',
    name: '404',
    component: NotFroundView,
  },

  {
    path: '/500',
    name: '500',
    component: ErrorView,
  },
  {
    path: '/demo',
    name: 'Demo',
    component: DemoView,
  },
  {
    path: '/demo-chat',
    name: 'DemoChat',
    component: DemoChatView,
  },
  {
    path: '/user-protocol',
    name: 'UserProtocol',
    component: UserProtocolView,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyView,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    redirect: '/404',
  },
]
